import { styled } from "styled-components";

export const MyListContaier = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 32px;

  width: 600px;
  border: 1px solid #383838;
  border-radius: 30px;
`;
